import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import './WaitlistedNotification.scss';
function WaitlistedNotification(_ref) {
  var consultantName = _ref.consultantName,
    handleShowQuestion = _ref.handleShowQuestion,
    handleShowCoworkerModal = _ref.handleShowCoworkerModal,
    handleCloseModal = _ref.handleCloseModal,
    isEmployer = _ref.isEmployer,
    showModal = _ref.showModal;
  return /*#__PURE__*/React.createElement(Modal, {
    show: showModal,
    onHide: handleCloseModal,
    dialogClassName: "waitlist-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", {
    className: "info-container"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "header"
  }, "Ok!\xA0", consultantName, "\xA0has been Waitlisted"), "You can revisit this proposal at a later time if you choose.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, "What would you like to do next?")), /*#__PURE__*/React.createElement("div", {
    className: "buttonContainer"
  }, isEmployer && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn--border-darkest",
    onClick: handleShowQuestion
  }, "I have questions about this candidate / proposal"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn--border-darkest",
    onClick: handleShowCoworkerModal
  }, "I need feedback from a colleague"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn--border-darkest",
    onClick: handleCloseModal
  }, "All set for now"))));
}
WaitlistedNotification.propTypes = {
  consultantName: PropTypes.string.isRequired,
  handleShowQuestion: PropTypes.func.isRequired,
  handleShowCoworkerModal: PropTypes.func.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  isEmployer: PropTypes.bool.isRequired,
  showModal: PropTypes.bool.isRequired
};
WaitlistedNotification.defaultProps = {};
export default WaitlistedNotification;